import React, { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import PictureWall from "@radarly/components/widgets/picture-wall";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { usePostsWidgetData } from "@radarly/core/widgets/use-cases";
import { Post } from "@radarly/models/posts";
import { SearchFragmentPosts } from "@radarly/models/search";
import Empty from "../../empty";
import Loading from "../../loading";
import { getEnrichedPosts } from "./utils";

export interface SharedWidgetsPostsPictureWallProps {
  project: number;
  fragment: SearchFragmentPosts;
  className?: string;
  onClick?: () => void;
  forceReload?: boolean;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
}

export default function SharedWidgetsPostsPictureWall({
  project,
  fragment,
  forceReload,
  onClick,
  className,
  isFullscreen,
  closeFullscreen,
}: SharedWidgetsPostsPictureWallProps) {
  const queryClient = useQueryClient();
  const [isDataFetched, setIsDatafetched] = useState(false);
  const [enrichedPosts, setEnrichedPosts] = useState<Post[]>([]);

  const { loading, posts, timezone, isEmpty, isError } = usePostsWidgetData(
    project,
    fragment
  );
  const locale = useCurrentUserLocale();
  const currentProject = useCurrentProject();
  const _onClick = () => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClick();
  };

  useEffect(() => {
    if (!loading && !isError) {
      getEnrichedPosts(posts, fragment, queryClient)
        .then((_posts) => setEnrichedPosts(_posts))
        .finally(() => setIsDatafetched(true));
    }
  }, [isError, loading, posts, queryClient, fragment]);

  return (
    <Loading loading={!isDataFetched} forceReload={forceReload}>
      <Empty empty={isEmpty}>
        <PictureWall
          posts={enrichedPosts}
          project={currentProject}
          timezone={timezone}
          locale={locale}
          className={className}
          onClick={onClick ? _onClick : null}
        />
      </Empty>
    </Loading>
  );
}
